import { render, staticRenderFns } from "./PeerGroupSettingsRoleEditor.vue?vue&type=template&id=1988e390&scoped=true&"
import script from "./PeerGroupSettingsRoleEditor.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupSettingsRoleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupSettingsRoleEditor.vue?vue&type=style&index=0&id=1988e390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988e390",
  null
  
)

export default component.exports